import tokenSource from '../config/tokenSource';
import { getApiBaseUrl } from '../utils/apiHost';

let isUimTokenSourceRegistered = false;

const TokenSourceMixin = (authUrl, proxy = false, options = {}) => {
  return {
    name: 'token-source-mixin',
    data() {
      return {
        defaultConfig: {
          settings: {
            environment: 'QA',
            tokenSource: tokenSource.name,
          },
        },
        tokenSourceOptions: {
          ...tokenSource,
          refreshToken: this.refreshTokenWrapper,
        },
      };
    },
    created() {
      if (!isUimTokenSourceRegistered) {
        window.mwc.dataAccess.registerTokenSource(this.tokenSourceOptions);
        isUimTokenSourceRegistered = true;
      }
    },
    methods: {
      getApiBaseUrl(url) {
        return getApiBaseUrl(url, this.settings.environment, proxy);
      },
      refreshTokenWrapper(callback) {
        let requestOptions = options;
        if (!proxy) {
          requestOptions = {
            ...options,
            credentials: 'include',
          };
        }
        window.mwc.dataAccess
          .fetch({
            url: this.getApiBaseUrl(authUrl),
            method: 'GET',
            headers: {
              'Content-type': 'application/json',
            },
            ...requestOptions,
            maxSleep: 100,
            minSleep: 10,
            maxAttempts: 3,
          })
          .then(res => res.json())
          .then(data => data.token)
          .then(token => {
            callback(null, token);
          });
      },
    },
  };
};

export default TokenSourceMixin;
